import * as React from 'react';

export interface IProductListRowShimmerProps {
    className?: string;
}

function randomWidth(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const ProductListRowShimmer: React.FC<IProductListRowShimmerProps> = (props) => {
    const {
        className
    } = props;

    const categoryWidth = React.useMemo(() => randomWidth(33, 171), []);
    const nameWidth = React.useMemo(() => randomWidth(130, 405), []);
    const skuWidth = React.useMemo(() => randomWidth(43, 50), []);
    const producerWidth = React.useMemo(() => randomWidth(50, 145), []);
    const conversionWidth = React.useMemo(() => randomWidth(16, 81), []);
    const priceWidth = React.useMemo(() => randomWidth(96, 116), []);

    return (
        <li>
            <div className={`${className}__product-image`}>
                <div className={`${className}__product-image__shimmer`} />
            </div>

            <div className={`${className}__product-wrapper`}>
                <div className={`${className}__product`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: categoryWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: nameWidth, height: 24 }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: skuWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: producerWidth }} />
                    <div className={`${className}__product__shimmer-line`} style={{ width: conversionWidth }} />
                </div>
            </div>

            <div className={`${className}__right`}>
                <div className={`${className}__price-and-indicators`}>
                    <div className={`${className}__prices-wrapper`}>
                        <div className={`${className}__product__shimmer-line`} style={{ width: priceWidth, height: 29, marginBottom: 10 }} />
                        <div className={`${className}__product__shimmer-line`} style={{ width: 90, height: 15 }} />
                        <div className={`${className}__product__shimmer-line`} style={{ width: 100, height: 15 }} />
                    </div>
                </div>

                <div className={`${className}__quantity-wrapper`} style={{ flexDirection: 'column', gap: 1 }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <div className={`${className}__product__shimmer-line`} style={{ width: 98, height: 34 }} />
                        <div className={`${className}__product__shimmer-line`} style={{ width: 143, height: 34 }} />
                    </div>
                    <div>
                        <div className={`${className}__product__shimmer-line`} style={{ width: 74, height: 12 }} />
                    </div>
                </div>
            </div>

            <div className={`${className}__bottom`}>
                <div className={`${className}__bottom-left`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: 144, height: 30, marginBottom: 0 }} />
                </div>
                <div className={`${className}__actions`}>
                    <div className={`${className}__product__shimmer-line`} style={{ width: 144, height: 38, marginBottom: 0 }} />
                </div>
            </div>
        </li>
    );
};

export default ProductListRowShimmer;
